export * from './save-preferences.graphql';
